var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesStandard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    d: "M33.5,219.7c0,0,0,2.1-0.3,3 c-0.6,1.4,0.4,1.8,0.4,1.8h165.5c0,0,0.9-0.2,0.4-1.6c-0.3-1.8-0.6-3.2-0.6-3.2H33.5L33.5,219.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    d: "M33.5,215.5c0,0,0.1,1.5-0.3,3 c-0.9,1.8,0.4,1.8,0.4,1.8h165.5c0,0,0.9-0.2,0.4-1.6c-0.3-1.8-0.6-3.2-0.6-3.2H33.5L33.5,215.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    d: "M35.6,53.7h163.6L199,188.1 c0,0,0.1,0.9,0,3.4c0.4,1.5,0.8,24.2-0.4,24.2c-1.3,0-161.3,0-164.5,0c-2.3,0-0.7-22.3-1-27c0-1.1,0-135,0-135L35.6,53.7 L35.6,53.7z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 76.1,
    x2: 199.2,
    y2: 76.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 103,
    x2: 199.2,
    y2: 103
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 131.2,
    x2: 199.2,
    y2: 131.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 160.9,
    x2: 199.2,
    y2: 160.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.7979,
    strokeMiterlimit: 10,
    x1: 33.1,
    y1: 190.1,
    x2: 199.2,
    y2: 190.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesStandard3);
export default __webpack_public_path__ + "static/media/FeaturesStandard3.a7a9291509159beacd49b2885d6de383.svg";
export { ForwardRef as ReactComponent };